var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');

var Features = createReactClass({

    componentDidMount: function() {
        this.$diagram = $('#diagram');
        this.$features = $('.features');
        this.$featureEles = $('.feature');

        this.addOrbitFeatureIfNeeded();
        $(window).on('changed.zf.mediaquery', this.mediaqueryChangedHandler);
    },

    componentWillUnmount: function(){
        this.removeOrbitFeatureIfNeeded();
        $(window).off('changed.zf.mediaquery', this.mediaqueryChangedHandler);
    },

    addOrbitFeatureIfNeeded: function(){
        if(Foundation.MediaQuery.current !== 'small'){
            this.$features.on('mouseenter', '.feature', this.handleFeatureHover);
            return;
        }

        this.$features.addClass('orbit-container');
        this.$featureEles.addClass('orbit-slide');
        this.$diagram.append(`<nav class="orbit-bullets">
          <button class="is-active" data-slide="0"><span class="show-for-sr">Track your progress</span><span class="show-for-sr">Current Slide</span></button>
          <button data-slide="1"><span class="show-for-sr">Uncover the emotional connection</span></button>
          <button data-slide="2"><span class="show-for-sr">Understand your symptoms</span></button>
          <button data-slide="3"><span class="show-for-sr">Get more from your doctor's visit</span></button>
          <button data-slide="4"><span class="show-for-sr">Understand your treatment options</span></button>
        </nav>`);

        new Foundation.Orbit(this.$diagram, {
            autoPlay: false
        });
    },

    removeOrbitFeatureIfNeeded: function(){
        if(!this.$diagram.find('.orbit-container').length){
            this.$features.off('hover', '.feature', this.handleFeatureHover);
            return;
        }

        this.$diagram.off('resizeme.zf.trigger');
        this.$diagram.foundation('destroy').attr('style', '');
        this.$features.removeClass('orbit-container').attr('style', '');
        this.$featureEles.removeClass('orbit-slide').attr('style', '');
        this.$diagram.find('.orbit-bullets').remove();
    },

    mediaqueryChangedHandler: function(){
        if(Foundation.MediaQuery.current !== 'small'){
            this.removeOrbitFeatureIfNeeded();
        }else {
            this.addOrbitFeatureIfNeeded();
        }
    },

    handleFeatureHover: function(e){
        var $activeFeature = $(e.currentTarget);
        this.$featureEles.removeClass('active');
        $activeFeature.addClass('active');
        this.$diagram.attr('class', $activeFeature.attr('id'));
    },

    render: function(){
        return (
            <div id="secondary">
                <div className="row heading">
                    <h2>Features</h2>
                </div>
                <div className="row">
                    <section id="diagram" className="one">
                        <div className="medium-5 large-4 show-for-medium column">
                            <div className="iphone-wrapper">
                                <div className="iphone">
                                    <div className="screen welcome"></div>
                                </div>
                            </div>
                        </div>
                        <div className="large-8 medium-7 column end features-container">
                            <div className="features">
                                <div className="feature active" id="one">
                                    <div className="iphone-wrapper hide-for-medium">
                                        <div className="iphone">
                                            <div className="screen"></div>
                                        </div>
                                    </div>
                                    <h3>Track your progress</h3>
                                    <p>Discover patterns and chart your improvement over time</p>
                                </div>
                                <div className="feature" id="two">
                                    <div className="iphone-wrapper hide-for-medium">
                                        <div className="iphone">
                                            <div className="screen"></div>
                                        </div>
                                    </div>
                                    <h3>Uncover the emotional connection</h3>
                                    <p>Connect the dots between your symptoms and your emotions</p>
                                </div>
                                <div className="feature" id="three">
                                    <div className="iphone-wrapper hide-for-medium">
                                        <div className="iphone">
                                            <div className="screen"></div>
                                        </div>
                                    </div>
                                    <h3>Understand your symptoms</h3>
                                    <p>Learn about the connection between your body and your symptoms</p>
                                </div>
                                <div className="feature" id="four">
                                    <div className="iphone-wrapper hide-for-medium">
                                        <div className="iphone">
                                            <div className="screen"></div>
                                        </div>
                                    </div>
                                    <h3>Get more from your doctor&#39;s visit</h3>
                                    <p>Complete your GI History to help you prepare for your consultation</p>
                                </div>
                                <div className="feature" id="five">
                                    <div className="iphone-wrapper hide-for-medium">
                                        <div className="iphone">
                                            <div className="screen"></div>
                                        </div>
                                    </div>
                                    <h3>Understand your treatment options</h3>
                                    <p>Learn about the different therapies available</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
});

module.exports = Features;



// WEBPACK FOOTER //
// ./src/common/routes/app/components/layout/features.jsx